import { get } from '.';
import qs from 'qs';

export const getAccreditations = ({ filters }) => {
  return get(`/accreditations?${qs.stringify(filters)}`);
};
